module.exports = __webpack_public_path__ + "img/md5-normal7.9564b68b.png";